<template>
  <div style="border-bottom: 1px solid #e3e3e3">
    <v-container class="pa-5" fluid>
      <v-row no-gutters class="mb-4 grey--text text--darken-3 text-h5">
        <v-col cols="12" class="text-h6 text-lg-h5 font-weight-regular">
          {{ title }} <tooltip-component :text="tooltip" />
        </v-col>
      </v-row>
      <div class="mb-3 d-flex justify-end">
        <div style="width: 170px" class="mr-1">
          <v-select
            class="text-subtitle-2 text-lg-subtitle-1 font-weight-regular"
            dense
            hide-details
            :menu-props="{ bottom: true, offsetY: true }"
            v-model="issuedCertificatesTimeRangeModel"
            :items="issuedCertificatesTimeRangeItems"
            item-text="name"
            @input="timeRangeChanged"
            data-cy="select-procedure"
            outlined
          ></v-select>
        </div>
        <div style="width: 170px; z-index: 9">
          <v-select
            class="text-subtitle-2 text-lg-subtitle-1 font-weight-regular"
            hide-details
            dense
            :menu-props="{ bottom: true, offsetY: true }"
            v-model="caModel"
            :items="getCAs"
            item-value="subject"
            item-text="name"
            outlined
            return-object
            @input="caChanged"
          ></v-select>
        </div>
      </div>
      <v-row no-gutters>
        <v-col cols="12">
          <span
            class="mr-1 blue--text text--darken-4"
            :class="{
              'font-two': $vuetify.breakpoint.mdAndDown,
              'font-two-five': $vuetify.breakpoint.lgAndUp,
            }"
          >
            {{ showInFixedForm(total) }}
          </span>
          <span class="font-certificates text-weight-regular">Certificates</span>
        </v-col>
        <v-col
          cols="12"
          class="mt-2 text-md-subtitle-2 text-lg-subtitle-1 font-weight-regular"
        >
          {{ fromDate }} - {{ toDate }} for
          <span v-if="caModel === 'All CAs'">All CAs</span>
          {{ caModel.name }}
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TooltipComponent from "@/components/global/tooltip-component.vue";
import moment from "moment/moment";
import { mapGetters } from "vuex";

export default {
  name: "reports-heading",
  components: { TooltipComponent },
  props: ["title", "total", "tooltip"],
  data() {
    return {
      fromDate: moment.utc().startOf("week").format("DD MMM YYYY"),
      toDate: moment.utc().format("DD MMM YYYY"),
      issuedCertificatesTimeRangeModel: "This week",
      issuedCertificatesTimeRangeItems: [
        "This week",
        "Last week",
        "This month",
        "Last month",
      ],
      caModel: "All CAs",
      dateString: "",
      firstDate: new Date(),
      timeRangeType: "week",
    };
  },
  computed: {
    ...mapGetters(["getCAs", "getIssuedCertificates"]),
  },
  mounted() {
    this.setThisWeekAsDefault();
    this.timeRangeChanged();
  },
  methods: {
    setThisWeekAsDefault() {
      let datesArray = [];
      this.fromDate = moment.utc().startOf("isoWeek").format("DD MMM YYYY");
      this.toDate = moment.utc().endOf("isoWeek").format("DD MMM YYYY");
      datesArray.push(this.formatBreakpoint(moment.utc().startOf("isoWeek")));
      datesArray.push(this.formatBreakpoint(moment.utc().endOf("isoWeek")));
      this.dateString = datesArray.join(",");
      // this.dateString = 'breakpoints=' + this.dateString
    },
    formatBreakpoint(moment) {
      return moment.utc().format("YYYYMMDDHHmmss[Z]");
    },
    caChanged() {
      let params = {
        breakpoints: this.dateString,
      };
      if (this.caModel?.subject) {
        params.issuer = this.caModel.subject;
      }
      this.$emit("callSetReports", {
        params: params,
        firstDate: this.firstDate,
        timeRangeType: this.timeRangeType,
      });
    },
    timeRangeChanged() {
      let datesArray = [];
      let revokedArray = [];
      // let firstDate = new Date();

      if (this.issuedCertificatesTimeRangeModel === "This week") {
        this.timeRangeType = "week";
        this.fromDate = moment.utc().startOf("isoWeek").format("DD MMM YYYY");
        this.toDate = moment.utc().endOf("isoWeek").format("DD MMM YYYY");

        if (this.title === "Revoked certificates") {
          this.firstDate = moment.utc().startOf("isoWeek");
          for (let i = 0; i < 8; i++) {
            revokedArray.push(
              this.formatBreakpoint(moment.utc(this.firstDate).add(i, "days"))
            );
          }
          this.dateString = revokedArray.join(",");
        } else if (this.title === "Issued certificates") {
          datesArray.push(this.formatBreakpoint(moment.utc().startOf("isoWeek")));
          datesArray.push(this.formatBreakpoint(moment.utc().endOf("isoWeek")));
          this.dateString = datesArray.join(",");
        }
      }

      if (this.issuedCertificatesTimeRangeModel === "Last week") {
        this.timeRangeType = "week";
        this.fromDate = moment
          .utc()
          .subtract(1, "weeks")
          .startOf("isoWeek")
          .format("DD MMM YYYY");
        this.toDate = moment
          .utc()
          .subtract(1, "weeks")
          .endOf("isoWeek")
          .format("DD MMM YYYY");
        if (this.title === "Revoked certificates") {
          this.firstDate = moment.utc().subtract(1, "weeks").startOf("isoWeek");
          for (let i = 0; i < 8; i++) {
            revokedArray.push(
              this.formatBreakpoint(moment.utc(this.firstDate).add(i, "days"))
            );
          }
          this.dateString = revokedArray.join(",");
        } else if (this.title === "Issued certificates") {
          datesArray.push(
            this.formatBreakpoint(moment.utc().subtract(1, "weeks").startOf("isoWeek"))
          );
          datesArray.push(
            this.formatBreakpoint(moment.utc().subtract(1, "weeks").endOf("isoWeek"))
          );
          this.dateString = datesArray.join(",");
        }
      }

      if (this.issuedCertificatesTimeRangeModel === "This month") {
        this.timeRangeType = "month";
        this.fromDate = moment.utc().startOf("month").format("DD MMM YYYY");
        this.toDate = moment.utc().endOf("month").format("DD MMM YYYY");

        if (this.title === "Revoked certificates") {
          this.firstDate = moment.utc().startOf("month");
          for (let i = 0; i < moment.utc().daysInMonth() + 1; i++) {
            revokedArray.push(
              this.formatBreakpoint(moment.utc(this.firstDate).add(i, "days"))
            );
          }
          this.dateString = revokedArray.join(",");
        } else {
          datesArray.push(this.formatBreakpoint(moment.utc().startOf("month")));
          datesArray.push(this.formatBreakpoint(moment.utc().endOf("month")));
          this.dateString = datesArray.join(",");
        }
      }

      if (this.issuedCertificatesTimeRangeModel === "Last month") {
        this.timeRangeType = "month";
        const fromPlainDateFormat = moment.utc().subtract(1, "months").startOf("month");
        const toPlainDateFormat = moment.utc().subtract(1, "months").endOf("month");
        this.fromDate = fromPlainDateFormat.format("DD MMM YYYY");
        this.toDate = toPlainDateFormat.format("DD MMM YYYY");

        if (this.title === "Revoked certificates") {
          this.firstDate = moment.utc().subtract(1, "months").startOf("month");
          for (let i = 0; i < moment.utc().subtract(1, "months").daysInMonth() + 1; i++) {
            revokedArray.push(
              this.formatBreakpoint(
                moment.utc().subtract(1, "months").startOf("month").add(i, "days")
              )
            );
          }
          this.dateString = revokedArray.join(",");
        } else {
          datesArray.push(this.formatBreakpoint(fromPlainDateFormat));
          datesArray.push(this.formatBreakpoint(toPlainDateFormat));
          this.dateString = datesArray.join(",");
        }
      }

      let params = {
        breakpoints: this.dateString,
      };
      if (this.caModel?.subject) {
        params.issuer = this.caModel.subject;
      }
      this.$emit("callSetReports", {
        params: params,
        firstDate: this.firstDate,
        timeRangeType: this.timeRangeType,
      });
    },
    showInFixedForm(number) {
      return Math.abs(number) > 999
        ? Math.sign(number) * (Math.abs(number) / 1000).toFixed(1) + "K"
        : Math.sign(number) * Math.abs(number);
    },
  },
};
</script>

<style scoped lang="scss">
@media only screen and (min-width: 1920px) {
  .font-certificates {
    font-size: 1.5rem;
  }
}
@media only screen and (max-width: 1919px) {
  .font-certificates {
    font-size: 1.25rem;
  }
}
.font-two-five {
  font-size: 2rem;
}
.font-two {
  font-size: 1.25rem;
}
</style>
